import { render } from "./App.vue?vue&type=template&id=334da2dd&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=334da2dd&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\e394cd1ec4c7054f\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334da2dd"]])

export default __exports__